// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL;

// const ListOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const userId = localStorage.getItem("userId");

//   const fetchOrders = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_URL}/order/user/${userId}`);
//       setOrders(res.data.data);
//       console.log(res.data.data);
//     } catch (err) {
//       console.error("Error fetching user orders:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const getStatusColor = (status) => {
//     const colors = {
//       pending: '#f59e0b',
//       processing: '#3b82f6',
//       shipped: '#8b5cf6',
//       delivered: '#10b981',
//       cancelled: '#ef4444'
//     };
//     return colors[status.toLowerCase()] || '#6b7280';
//   };

//   if (loading) {
//     return (
//       <>
//         <style>{`
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }
//         `}</style>
//         <div style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: '400px',
//           gap: '1rem'
//         }}>
//           <div style={{
//             width: '50px',
//             height: '50px',
//             border: '4px solid #e5e7eb',
//             borderTopColor: '#3b82f6',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite'
//           }}></div>
//           <p style={{ color: '#6b7280', fontSize: '1rem' }}>Loading your orders...</p>
//         </div>
//       </>
//     );
//   }

//   if (orders.length === 0) {
//     return (
//       <div style={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '4rem 2rem',
//         textAlign: 'center',
//         minHeight: '400px'
//       }}>
//         <div style={{ fontSize: '5rem', marginBottom: '1.5rem', opacity: 0.5 }}>📦</div>
//         <h3 style={{ 
//           fontSize: '1.75rem', 
//           fontWeight: 600, 
//           color: '#111827', 
//           marginBottom: '0.75rem',
//           margin: '0 0 0.75rem 0'
//         }}>
//           No Orders Yet
//         </h3>
//         <p style={{ 
//           color: '#6b7280', 
//           marginBottom: '2rem',
//           fontSize: '1.1rem',
//           margin: '0 0 2rem 0'
//         }}>
//           You haven't placed any orders yet. Start shopping now!
//         </p>
//         <Link to="/shop" style={{
//           padding: '0.75rem 2rem',
//           background: '#111827',
//           color: 'white',
//           textDecoration: 'none',
//           borderRadius: '6px',
//           fontWeight: 500,
//           fontSize: '0.9375rem',
//           transition: 'all 0.2s ease',
//           display: 'inline-block'
//         }}>
//           Start Shopping
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         .order-card-item {
//           transition: all 0.2s ease;
//           border: 1px solid #e5e7eb;
//         }
//         .order-card-item:hover {
//           border-color: #d1d5db;
//           box-shadow: 0 2px 8px rgba(0,0,0,0.06);
//         }
//         .order-item-img {
//           transition: transform 0.2s ease;
//         }
//         .order-item-img-wrap:hover .order-item-img {
//           transform: scale(1.05);
//         }
//         .view-btn {
//           transition: all 0.2s ease;
//         }
//         .view-btn:hover {
//           background: #111827;
//         }

//         @media (max-width: 768px) {
//           .order-header-flex { 
//             flex-direction: column !important; 
//             align-items: flex-start !important; 
//             gap: 1rem; 
//           }
//           .order-footer-flex { 
//             flex-direction: column !important; 
//             align-items: stretch !important; 
//           }
//           .order-item-img-wrap { 
//             width: 70px !important; 
//             height: 70px !important; 
//           }
//           .view-btn { 
//             width: 100% !important; 
//             text-align: center !important;
//             justify-content: center !important;
//           }
//           .order-summary-grid {
//             gap: 0.75rem !important;
//           }
//         }

//         @media (max-width: 480px) {
//           .order-item-img-wrap { 
//             width: 60px !important; 
//             height: 60px !important; 
//           }
//           .item-name-text {
//             font-size: 0.9rem !important;
//           }
//         }
//       `}</style>

      

//       <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//         {orders.map((order) => (
//           <div key={order._id} className="order-card-item" style={{
//             background: 'white',
//             borderRadius: '8px',
//             overflow: 'hidden'
//           }}>
            
//             {/* Header */}
//             <div className="order-header-flex" style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               padding: '1rem 1.25rem',
//               background: '#fafafa',
//               borderBottom: '1px solid #e5e7eb'
//             }}>
//               <div>
//                 <h4 style={{ 
//                   fontSize: '1rem', 
//                   fontWeight: 600, 
//                   color: '#111827', 
//                   margin: '0 0 0.25rem 0'
//                 }}>
//                   Order #{order._id.slice(-6).toUpperCase()}
//                 </h4>
//                 <p style={{ 
//                   fontSize: '0.875rem', 
//                   color: '#6b7280', 
//                   margin: 0
//                 }}>
//                   {new Date(order.createdAt).toLocaleDateString('en-IN', { 
//                     day: 'numeric', 
//                     month: 'short', 
//                     year: 'numeric' 
//                   })}
//                 </p>
//               </div>
//               <span style={{
//                 padding: '0.375rem 0.875rem',
//                 borderRadius: '4px',
//                 fontSize: '0.8125rem',
//                 fontWeight: 500,
//                 color: 'white',
//                 backgroundColor: getStatusColor(order.status),
//                 textTransform: 'capitalize'
//               }}>
//                 {order.status}
//               </span>
//             </div>

//             {/* Items */}
//             <div style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//               {order.items.slice(0, 3).map((item, idx) => (
//                 <div key={idx} style={{ 
//                   display: 'flex', 
//                   gap: '1rem', 
//                   alignItems: 'center',
//                   padding: '0.75rem',
//                   background: '#fafafa',
//                   borderRadius: '6px'
//                 }}>
//                   <div className="order-item-img-wrap" style={{
//                     width: '70px',
//                     height: '70px',
//                     borderRadius: '6px',
//                     overflow: 'hidden',
//                     background: 'white',
//                     flexShrink: 0,
//                     border: '1px solid #e5e7eb'
//                   }}>
//                     <img 
//                       className="order-item-img"
//                       src={item.images?.[0] || 'https://via.placeholder.com/80'} 
//                       alt={item.name}
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover'
//                       }}
//                       onError={(e) => e.target.src = 'https://via.placeholder.com/80'}
//                     />
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <h5 className="item-name-text" style={{
//                       fontSize: '0.9375rem',
//                       fontWeight: 500,
//                       color: '#111827',
//                       margin: '0 0 0.375rem 0',
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap'
//                     }}>
//                       {item.name}
//                     </h5>
//                     <div style={{ 
//                       display: 'flex', 
//                       gap: '1rem',
//                       flexWrap: 'wrap',
//                       fontSize: '0.8125rem'
//                     }}>
//                       <span style={{ color: '#6b7280' }}>
//                         Qty: {item.qty}
//                       </span>
//                       <span style={{ color: '#6b7280' }}>
//                         Price: ₹{item.price}
//                       </span>
//                       <span style={{ 
//                         color: '#111827',
//                         fontWeight: 600
//                       }}>
//                         {item.qty * item.price}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
              
//               {order.items.length > 3 && (
//                 <div style={{
//                   padding: '0.625rem',
//                   background: '#f3f4f6',
//                   borderRadius: '4px',
//                   textAlign: 'center',
//                   fontSize: '0.8125rem',
//                   color: '#6b7280',
//                   fontWeight: 500
//                 }}>
//                   +{order.items.length - 3} more item{order.items.length - 3 > 1 ? 's' : ''}
//                 </div>
//               )}
//             </div>

//             {/* Footer */}
//             <div className="order-footer-flex" style={{
//               padding: '1rem 1.25rem',
//               background: '#fafafa',
//               borderTop: '1px solid #e5e7eb',
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               gap: '1rem'
//             }}>
//               <div className="order-summary-grid" style={{ 
//                 flex: 1,
//                 display: 'grid',
//                 gap: '0.5rem'
//               }}>
//                 <div style={{ 
//                   display: 'flex', 
//                   justifyContent: 'space-between',
//                   fontSize: '0.8125rem'
//                 }}>
//                   <span style={{ color: '#6b7280' }}>Payment Method:</span>
//                   <span style={{ 
//                     color: '#111827', 
//                     fontWeight: 500,
//                     textTransform: 'uppercase'
//                   }}>
//                     {order.paymentMethod}
//                   </span>
//                 </div>
//                 <div style={{ 
//                   display: 'flex', 
//                   justifyContent: 'space-between',
//                   paddingTop: '0.5rem',
//                   borderTop: '1px solid #e5e7eb'
//                 }}>
//                   <span style={{ 
//                     fontSize: '0.9375rem', 
//                     color: '#111827', 
//                     fontWeight: 600 
//                   }}>
//                     Total:
//                   </span>
//                   <span style={{ 
//                     fontSize: '1.125rem', 
//                     color: '#111827', 
//                     fontWeight: 600 
//                   }}>
//                     ₹{order.totalAmount}
//                   </span>
//                 </div>
//               </div>
//               <Link to={`/user/orders/${order._id}`} className="view-btn" style={{
//                 padding: '0.625rem 1.25rem',
//                 background: '#111827',
//                 color: 'white',
//                 textDecoration: 'none',
//                 borderRadius: '6px',
//                 fontWeight: 500,
//                 whiteSpace: 'nowrap',
//                 fontSize: '0.875rem'
//               }}>
//                 View Details
//               </Link>
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default ListOrders;

import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

/* ─── helpers ─────────────────────────────────────────── */
const STATUS_META = {
  pending:    { color: "#b45309", bg: "#fef3c7", label: "Pending" },
  processing: { color: "#1d4ed8", bg: "#dbeafe", label: "Processing" },
  shipped:    { color: "#6d28d9", bg: "#ede9fe", label: "Shipped" },
  delivered:  { color: "#065f46", bg: "#d1fae5", label: "Delivered" },
  cancelled:  { color: "#991b1b", bg: "#fee2e2", label: "Cancelled" },
};

const statusMeta = (s = "") =>
  STATUS_META[s.toLowerCase()] || { color: "#374151", bg: "#f3f4f6", label: s };

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

// Derive locale from currency code for correct digit grouping
const CURRENCY_LOCALE = {
  INR: "en-IN",
  USD: "en-US",
  EUR: "de-DE",
  GBP: "en-GB",
  AED: "ar-AE",
  SGD: "en-SG",
  AUD: "en-AU",
  CAD: "en-CA",
  JPY: "ja-JP",
};

const fmtMoney = (n, currency = "INR") => {
  const code = (currency || "INR").toUpperCase();
  const locale = CURRENCY_LOCALE[code] || "en-US";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: code,
    maximumFractionDigits: code === "JPY" ? 0 : 2,
  }).format(n);
};

// Resolve the order-level currency: prefer order.currency,
// fall back to the first item's currency, then default to INR.
const orderCurrency = (order) =>
  order.currency ||
  order.items?.[0]?.currency ||
  "INR";

/* ─── sub-components ───────────────────────────────────── */
const StatusBadge = ({ status }) => {
  const { color, bg, label } = statusMeta(status);
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "0.35rem",
      padding: "0.25rem 0.75rem",
      borderRadius: "999px",
      fontSize: "0.8rem",
      fontWeight: 600,
      color,
      backgroundColor: bg,
      letterSpacing: "0.02em",
    }}>
      <span style={{
        width: "7px", height: "7px",
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
      }} />
      {label}
    </span>
  );
};

const OrderItem = ({ item, currency }) => (
  <div style={{
    display: "flex",
    gap: "0.875rem",
    alignItems: "flex-start",
    padding: "0.75rem 0",
    borderBottom: "1px solid #f3f4f6",
  }}>
    <div style={{
      width: 72, height: 72,
      borderRadius: "6px",
      overflow: "hidden",
      flexShrink: 0,
      border: "1px solid #e5e7eb",
      background: "#f9fafb",
    }}>
      <img
        src={item.images?.[0] || "https://placehold.co/72x72?text=?"}
        alt={item.name}
        onError={(e) => { e.target.src = "https://placehold.co/72x72?text=?"; }}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <p style={{
        margin: "0 0 0.3rem 0",
        fontSize: "0.9rem",
        fontWeight: 500,
        color: "#0F1111",
        lineHeight: 1.4,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
      }}>
        {item.name}
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem 1rem", marginTop: "0.25rem" }}>
        {item.color && (
          <span style={{ fontSize: "0.78rem", color: "#6B7280" }}>
            Color: <b style={{ color: "#374151" }}>{item.color}</b>
          </span>
        )}
        {item.size && (
          <span style={{ fontSize: "0.78rem", color: "#6B7280" }}>
            Size: <b style={{ color: "#374151" }}>{item.size}</b>
          </span>
        )}
        <span style={{ fontSize: "0.78rem", color: "#6B7280" }}>
          Qty: <b style={{ color: "#374151" }}>{item.qty}</b>
        </span>
      </div>
    </div>
    <div style={{ textAlign: "right", flexShrink: 0 }}>
      <p style={{ margin: 0, fontWeight: 700, fontSize: "0.9375rem", color: "#0F1111" }}>
        {fmtMoney(item.price * item.qty, currency)}
      </p>
      <p style={{ margin: "0.15rem 0 0 0", fontSize: "0.76rem", color: "#6B7280" }}>
        {fmtMoney(item.price, currency)} × {item.qty}
      </p>
    </div>
  </div>
);

const OrderCard = ({ order }) => {
  const currency = orderCurrency(order);
  const fmt = (n) => fmtMoney(n, currency);

  const shippingTo = order.shipping?.city
    ? `${order.shipping.city}, ${order.shipping.state}`
    : null;

  const previewItems = order.items.slice(0, 3);
  const extraCount = order.items.length - 3;

  return (
    <div style={{
      border: "1px solid #D5D9D9",
      borderRadius: "8px",
      overflow: "hidden",
      background: "white",
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
    }}>

      {/* ── Header ── */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.75rem",
        padding: "0.75rem 1.25rem",
        background: "#F0F2F2",
        borderBottom: "1px solid #D5D9D9",
      }}>
        {/* Left cluster */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem" }}>
          <div>
            <p style={{ margin: 0, fontSize: "0.7rem", fontWeight: 600, color: "#565959", textTransform: "uppercase", letterSpacing: "0.05em" }}>Order placed</p>
            <p style={{ margin: "0.2rem 0 0 0", fontSize: "0.875rem", color: "#0F1111", fontWeight: 500 }}>{fmtDate(order.createdAt)}</p>
          </div>
          <div>
            <p style={{ margin: 0, fontSize: "0.7rem", fontWeight: 600, color: "#565959", textTransform: "uppercase", letterSpacing: "0.05em" }}>Total</p>
            <p style={{ margin: "0.2rem 0 0 0", fontSize: "0.875rem", color: "#0F1111", fontWeight: 700 }}>{fmt(order.totalAmount)}</p>
          </div>
          <div>
            <p style={{ margin: 0, fontSize: "0.7rem", fontWeight: 600, color: "#565959", textTransform: "uppercase", letterSpacing: "0.05em" }}>Payment</p>
            <p style={{ margin: "0.2rem 0 0 0", fontSize: "0.875rem", color: "#0F1111", fontWeight: 500, textTransform: "uppercase" }}>{order.paymentMethod}</p>
          </div>
          {shippingTo && (
            <div>
              <p style={{ margin: 0, fontSize: "0.7rem", fontWeight: 600, color: "#565959", textTransform: "uppercase", letterSpacing: "0.05em" }}>Ship to</p>
              <p style={{ margin: "0.2rem 0 0 0", fontSize: "0.875rem", color: "#0F1111", fontWeight: 500 }}>{shippingTo}</p>
            </div>
          )}
        </div>

        {/* Right cluster */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.4rem" }}>
          <p style={{ margin: 0, fontSize: "0.72rem", color: "#565959" }}>
            ORDER # <span style={{ color: "#007185", fontWeight: 600, letterSpacing: "0.04em" }}>{order._id.slice(-8).toUpperCase()}</span>
          </p>
          <StatusBadge status={order.status} />
          <Link
            to={`/user/orders/${order._id}`}
            style={{
              fontSize: "0.8rem",
              color: "#007185",
              textDecoration: "none",
              fontWeight: 500,
            }}
          >
            View order details →
          </Link>
        </div>
      </div>

      {/* ── Body ── */}
      <div style={{ padding: "0.5rem 1.25rem" }}>
        {previewItems.map((item, i) => (
          <OrderItem key={item._id || i} item={item} currency={currency} />
        ))}

        {extraCount > 0 && (
          <div style={{
            padding: "0.6rem 0",
            fontSize: "0.825rem",
            color: "#007185",
            fontWeight: 500,
          }}>
            + {extraCount} more item{extraCount > 1 ? "s" : ""} in this order
          </div>
        )}
      </div>

      {/* ── Footer ── */}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.75rem",
        padding: "0.75rem 1.25rem",
        borderTop: "1px solid #f3f4f6",
        background: "#FAFAFA",
      }}>
        {/* Price breakdown */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1.25rem" }}>
          {order.delivery > 0 && (
            <span style={{ fontSize: "0.8rem", color: "#565959" }}>
              Delivery: <b style={{ color: "#0F1111" }}>{fmt(order.delivery)}</b>
            </span>
          )}
          {order.tax > 0 && (
            <span style={{ fontSize: "0.8rem", color: "#565959" }}>
              Tax: <b style={{ color: "#0F1111" }}>{fmt(order.tax)}</b>
            </span>
          )}
          {order.delivery === 0 && (
            <span style={{
              fontSize: "0.78rem",
              color: "#007600",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "0.3rem",
            }}>
              ✓ Free delivery
            </span>
          )}
          <span style={{ fontSize: "0.8rem", color: "#565959" }}>
            Payment status:{" "}
            <b style={{
              color: order.paymentStatus === "PAID" ? "#007600" : "#b45309",
            }}>
              {order.paymentStatus}
            </b>
          </span>
        </div>

        <Link
          to={`/user/orders/${order._id}`}
          style={{
            padding: "0.5rem 1.25rem",
            background: "#FFD814",
            color: "#0F1111",
            border: "1px solid #C7A600",
            borderRadius: "6px",
            fontWeight: 600,
            fontSize: "0.875rem",
            textDecoration: "none",
            whiteSpace: "nowrap",
            transition: "background 0.15s",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#F7CA00")}
          onMouseLeave={(e) => (e.target.style.background = "#FFD814")}
        >
          Track / View Details
        </Link>
      </div>
    </div>
  );
};

/* ─── loading skeleton ─────────────────────────────────── */
const Skeleton = () => (
  <>
    <style>{`
      @keyframes shimmer {
        0%   { background-position: -600px 0; }
        100% { background-position: 600px 0; }
      }
      .sk { background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 600px; animation: shimmer 1.4s infinite linear; border-radius: 4px; }
    `}</style>
    {[1, 2].map((n) => (
      <div key={n} style={{ border: "1px solid #D5D9D9", borderRadius: "8px", overflow: "hidden" }}>
        <div style={{ padding: "0.75rem 1.25rem", background: "#F0F2F2", borderBottom: "1px solid #D5D9D9", display: "flex", gap: "2rem" }}>
          {[80, 60, 70].map((w, i) => (
            <div key={i}>
              <div className="sk" style={{ width: 50, height: 10, marginBottom: 8 }} />
              <div className="sk" style={{ width: w, height: 14 }} />
            </div>
          ))}
        </div>
        <div style={{ padding: "1.25rem" }}>
          {[1, 2].map((k) => (
            <div key={k} style={{ display: "flex", gap: "1rem", paddingBottom: "1rem", marginBottom: "0.5rem", borderBottom: "1px solid #f3f4f6" }}>
              <div className="sk" style={{ width: 72, height: 72, borderRadius: 6, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div className="sk" style={{ height: 12, marginBottom: 8 }} />
                <div className="sk" style={{ height: 12, width: "60%" }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </>
);

/* ─── main component ───────────────────────────────────── */
const ListOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = localStorage.getItem("userId");

  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await axios.get(`${API_URL}/order/user/${userId}`);
      setOrders(res.data.data || []);
    } catch (err) {
      console.error("Error fetching user orders:", err);
      setError("We couldn't load your orders. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); }, []);

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", maxWidth: 860, margin: "0 auto", padding: "1.5rem 1rem" }}>

      {/* Page title */}
      <div style={{ marginBottom: "1.5rem", borderBottom: "1px solid #e5e7eb", paddingBottom: "1rem" }}>
        <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 700, color: "#0F1111" }}>Your Orders</h2>
        {!loading && !error && (
          <p style={{ margin: "0.35rem 0 0 0", fontSize: "0.875rem", color: "#565959" }}>
            {orders.length} order{orders.length !== 1 ? "s" : ""} placed
          </p>
        )}
      </div>

      {/* States */}
      {loading && <Skeleton />}

      {!loading && error && (
        <div style={{
          padding: "2rem",
          textAlign: "center",
          border: "1px solid #fca5a5",
          borderRadius: "8px",
          background: "#fff1f2",
        }}>
          <p style={{ color: "#991b1b", fontWeight: 500, margin: "0 0 1rem 0" }}>{error}</p>
          <button
            onClick={fetchOrders}
            style={{
              padding: "0.5rem 1.5rem",
              background: "#FFD814",
              border: "1px solid #C7A600",
              borderRadius: "6px",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            Try Again
          </button>
        </div>
      )}

      {!loading && !error && orders.length === 0 && (
        <div style={{
          textAlign: "center",
          padding: "4rem 2rem",
          border: "1px solid #D5D9D9",
          borderRadius: "8px",
          background: "white",
        }}>
          <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>📦</div>
          <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.3rem", color: "#0F1111" }}>No orders yet</h3>
          <p style={{ margin: "0 0 1.75rem 0", color: "#565959", fontSize: "0.9375rem" }}>
            Looks like you haven't placed any orders. Start shopping!
          </p>
          <Link
            to="/shop"
            style={{
              padding: "0.625rem 1.75rem",
              background: "#FFD814",
              color: "#0F1111",
              textDecoration: "none",
              border: "1px solid #C7A600",
              borderRadius: "6px",
              fontWeight: 600,
              fontSize: "0.9rem",
            }}
          >
            Start Shopping
          </Link>
        </div>
      )}

      {!loading && !error && orders.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
          {orders.map((order) => (
            <OrderCard key={order._id} order={order} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ListOrders;